





































import { Component, Vue } from 'vue-property-decorator';
@Component({
  name: 'Maps',
})
export default class Maps extends Vue {
  public zoom = 12;
  public center = [121.59996, 31.197646];
  public address = '';
  public events: { click?: Function } = {};
  public lng = 0;
  public lat = 0;
  public mapDialog = false;
  public wait = false;
  public plugin: any = [];
  public searchOption = {
    city: '',
    citylimit: false,
  };
  public created() {
    this.plugin = [
      {
        pName: 'Geolocation',
        events: {
          init: (o: {
            getCurrentPosition: (
              arg0: (
                status: any,
                result: {
                  position: { lng: number; lat: number };
                  formattedAddress: string;
                }
              ) => void
            ) => void;
          }) => {
            o.getCurrentPosition(
              (
                _status: any,
                result: {
                  position: { lng: number; lat: number };
                  formattedAddress: string;
                }
              ) => {
                if (result && result.position) {
                  this.lng = result.position.lng;
                  this.lat = result.position.lat;
                  this.center = [this.lng, this.lat];
                  this.address = result.formattedAddress;
                }
              }
            );
          },
        },
      },
    ];
    this.events = {
      click: (e: any) => {
        const { lng, lat } = e.lnglat;
        this.lng = lng;
        this.lat = lat;
        const lngLat = [lng, lat];
        this.center = lngLat;
        const geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all',
        });
        geocoder.getAddress(
          lngLat,
          (
            status: string,
            result: { info: string; regeocode: { formattedAddress: string } }
          ) => {
            if (status === 'complete' && result.info === 'OK' && result.regeocode) {
              this.address = result.regeocode.formattedAddress;
            }
          }
        );
      },
    };
    this.wait = true;
  }
  public onSearchResult(pois: string | any[]) {
    if (pois.length > 0) {
      this.lng = pois[0].lng;
      this.lat = pois[0].lat;
      this.address = pois[0].address;
      this.center = [this.lng, this.lat];
    }
  }
  public mapConfirm() {
    this.$emit('confirm', this.lng, this.lat, this.address);
    this.mapDialog = false;
  }
}
